import { useSite } from 'src/context/providers/SiteProvider';

export const useFilterDrawer = () => {
  const { state, dispatch } = useSite();
  const { showDateAccordion, showSaveFilterModal, saveFilterType } =
    state.filterDrawer;

  const toggleSaveFilterModal = () => {
    dispatch({ type: 'TOGGLE_SAVE_FILTER_MODAL' });
  };

  const toggleDateAccordion = (value: boolean) => {
    dispatch({
      type: 'TOGGLE_DATE_ACCORDION',
      payload: value,
    });
  };

  const toggleManageFiltersModal = () => {
    dispatch({ type: 'TOGGLE_MANAGE_FILTERS_MODAL' });
  };

  const setSaveFilterType = (type: string) => {
    dispatch({ type: 'SET_SAVE_FILTER_TYPE', payload: type });
  };

  return {
    showDateAccordion,
    showSaveFilterModal,
    saveFilterType,
    toggleSaveFilterModal,
    toggleDateAccordion,
    toggleManageFiltersModal,
    setSaveFilterType,
  };
};
